import { lazy } from 'react';

const importCollectionView = widgetComponent =>
	lazy(() =>
		import(`components/widgets/collection/${widgetComponent}`).catch(() =>
			import(`components/widgets/NullView`)
		)
	);

export default importCollectionView;